import { useEffect, useRef } from 'react';

import { FAQ } from '@components/FAQ';
import { useDebounce } from '@hooks/useDebounce';
import { useIsInView } from '@hooks/useIsInView';
import {
  useTrackSignupMobileFaqExpanded,
  useTrackSignupMobileFaqsDisplayed,
} from '@tracking/trackingEvents';

import { faqSections } from './sections';

const MobileFAQ = () => {
  const ref = useRef(null);
  const trackSignupMobileFaqExpanded = useTrackSignupMobileFaqExpanded();
  const trackSignupMobileFaqsDisplayed = useTrackSignupMobileFaqsDisplayed();
  const debouncedMobileFaqsDisplayed = useDebounce(
    trackSignupMobileFaqsDisplayed,
    500
  );
  const faqInView = useIsInView(ref, { threshold: 0.5 });
  useEffect(() => {
    if (faqInView) {
      debouncedMobileFaqsDisplayed();
    }
  }, [faqInView, debouncedMobileFaqsDisplayed]);
  return (
    <FAQ
      ref={ref}
      sections={faqSections}
      onAccordionChange={(question: string, isExpanded: boolean) => {
        if (isExpanded) {
          trackSignupMobileFaqExpanded({ question });
        }
      }}
    />
  );
};

export { MobileFAQ };
